import { GenDialogProps } from "@ui";

import { CORE_ACTION } from "../types/CoreAction";

const openDialog = (dialog: Partial<GenDialogProps>) => {
  return {
    type: CORE_ACTION.UPDATE_DIALOG,
    payload: { dialog },
  };
};

export default openDialog;
